/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { fields, factoryT } from 'factory-t';
import { UserRole } from '../users/usersClient.typings';
import { DetailedUserDto, UserStatus } from './usersClient.typings';

export const detailedUserFactory = factoryT<DetailedUserDto>({
    id: (ctx) => ctx.index,
    status: fields.sequence([UserStatus.Active, UserStatus.Active, UserStatus.Inactive]),
    firstName: fields.sequence(['Ivan', 'Peter', 'Philip', 'Eugen', 'Andrey', 'Sergey']),
    middleName: fields.sequence(['Philipovich', null, 'Robertovich', 'Victorovich', null, null]),
    lastName: (ctx) => 'Ivanov' + ctx.index.toString(),
    registrationAtUtc: '2020-02-02T11:27:11.996063',
    deactivationDate: fields.sequence([null, '2021-02-02T11:27:11.996063']),
    email: (ctx) => `jps${ctx.index}@noogadev.com`,
    phone: fields.sequence([null, '+994 29 675-22-99', '+994 invalid', '+375 88', '+375767676', '']),
    roles: fields.sequence([
        [UserRole.Inspector, UserRole.Director, UserRole.Expert],
        [UserRole.CentralInspector],
        [UserRole.RegionalInspector],
        [UserRole.Operator],
        [UserRole.Taxpayer],
    ]),
    operatorName: fields.sequence(['', null, null, 'NBA INTERNATİONAL']), // for operators
    taxAuthorityId: fields.sequence(['23', '24', '25', null]), // for inspectors
    taxAuthorityName: fields.sequence(['TaxAuthority-23', 'TaxAuthority-24', 'TaxAuthority-25', null]), // for inspectors
});
